var React = require('react');

function ScrollDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5623 17.8487L8.93738 23.4735V0.34375H7.06238V23.4734L1.43762 17.8487L0.111816 19.1745L7.99994 27.0626L15.8881 19.1745L14.5623 17.8487Z","fill":"white"}));
}

ScrollDown.defaultProps = {"width":"16","height":"28","viewBox":"0 0 16 28","fill":"none"};

module.exports = ScrollDown;

ScrollDown.default = ScrollDown;
